











import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';

export default {
    components: {
        CoButton,
        CoText,
    },
    name: 'LoginAccountNotFoundStep',
    props: {
        email: {
            type: String,
            required: true,
        },
    },
    emits: ['back'],
    mounted() {
        // Announce the result through focus, with Back next in the keyboard tab order.
        this.$refs.guidance.$el.focus();
    },
};
